
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/kits/[handle]",
      function () {
        return require("private-next-pages/kits/[handle].ts");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/kits/[handle]"])
      });
    }
  